import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id CDAF170C-BB2C-4217-9B96-D99EE9B725F9
 * name home-plus-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-plus-outline.svg
 * tags
 * - Home Automation 
 */
export const HomePlusOutlineIcon = createSvgIcon(<><path d="M17 14H19V17H22V19H19V22H17V19H14V17H17V14M5 20V12H2L12 3L22 12H17V10.19L12 5.69L7 10.19V18H12C12 18.7 12.12 19.37 12.34 20H5Z" /></>, 'HomePlusOutlineIcon');
export default HomePlusOutlineIcon